export const EDITAR_INVENTARIO_DE_RISCO = "EDITAR_INVENTARIO_DE_RISCO";
export const LISTAR_INVENTARIO_DE_RISCO = "LISTAR_INVENTARIO_DE_RISCO";
export const LISTAR_INVENTARIO_DE_RISCO_DO_PROCESSO =
  "LISTAR_INVENTARIO_DE_RISCO_DO_PROCESSO";
export const LISTAR_EPC_EPI_MAO = "LISTAR_EPC_EPI_MAO";
export const REMOVER_INVENTARIO_DE_RISCO = "REMOVER_INVENTARIO_DE_RISCO";
export const LISTAR_FATORES_DE_RISCO_DISPONIVEIS =
  "LISTAR_FATORES_DE_RISCO_DISPONIVEIS";
